import React from 'react';

const features = [
    { title: 'TRACK', icon: 'images/track.svg' },
    { title: 'SHARE', icon: 'images/share.svg' },
    { title: 'EXPLORE', icon: 'images/explore.svg' }
];

function FeatureCard({ title, icon }) {
    return (
        <div className="flex-1 p-2">
            <div className="flex flex-col items-center p-6 h-full bg-gray-200 rounded-lg shadow-md transition-transform hover:scale-105">
                <img 
                    loading="lazy" 
                    src={icon} 
                    alt={`${title} icon`} 
                    className="w-16 h-16 object-contain mb-4"
                />
                <div className="text-2xl font-medium text-orange-400 text-center">
                    {title}
                </div>
            </div>
        </div>
    );
}

function Track() {
    return (
        <div className="py-2 bg-zinc-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-wrap -mx-2">
                    {features.map((feature, index) => (
                        <FeatureCard
                            key={index}
                            title={feature.title}
                            icon={feature.icon}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Track;